app.service('permissions', function () {
	var $self, $permisions, $checkAll;

	function toggleAllPermisions(checkAllPermisions) {
		if (checkAllPermisions) {
			$permisions.prop('checked', true);
			$permisions.valid();
		} else {
			$permisions.prop('checked', false);
		}
	}
	function setElements() {
		$self = $('#permissions');
		$permisions = $('.js-permission input:checkbox', $self);
		$checkAll = $('.permissions-check-all input');
	}
	function setEvents() {
		//Zaznacz wszystkie zgody
		$('#check-all-permissions', $self).on('click', function () {
			toggleAllPermisions($(this).prop('checked'));
		});
		//wylacz checkbox zaznacz wszystkie
		$permisions.on('click', function () {
			var allChecked = checkIfAllCheckboxesSelected();
			$checkAll.prop("checked", allChecked);
		});
		//Nie pokazuj przycisku zaznaczania wszystkich zgod jesli zgody sa juz zaakceptowane
		if (!$('.js-permission', $self).length) {
			$self.addClass('hide-check-all-agreement');
		}
	}
	function checkIfAllCheckboxesSelected() {
		return $permisions.not(':checked').length === 0;
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init: init
	};
});
